
import { defineComponent, ref } from '@vue/composition-api';
import { FCCard, IconButton } from '@fc/angie-ui';
import Section from '~/components/v5/Section.vue';
import SectionHeader from '~/components/v5/SectionHeader.vue';
import FCImage from '~/components/FCImage.vue';

export default defineComponent({
  name: 'TheScienceSection',
  components: {
    FCCard,
    FCImage,
    Section,
    SectionHeader,
    IconButton,
  },
  setup() {
    const expandedCards = ref<Set<number>>(new Set());

    const cards = [
      {
        img: 'https://a.storyblok.com/f/152150/6192x8256/96d1312b31/jared_improved_focus-1.jpg',
        title: 'Improved Focus',
        description: 'It’s very hard to box effectively and multitask... [Boxing] is a great opportunity to develop attention in the moment — accuracy, focus, concentration, and all of those things help develop your sense of self-confidence.',
        source: 'Ross Flowers, Sports Psychologist for college, Olympic, and professional athletes, including the Los Angeles Clippers and Los Angeles Rams. “The Mental and Physical Effects of Boxing”',
        alt: 'Person in a "Fight Camp" tank top and boxing gloves stands in a fighting stance near a punching bag in a basement setting.',
      },
      {
        img: 'https://a.storyblok.com/f/152150/5287x3525/ee57ceb672/kellie_stress_relief.jpg',
        title: 'Stress Relief Beyond Belief',
        description: 'The act of hitting a punching bag during a boxing workout can serve as a form of catharsis, allowing individuals to physically express frustration or anger in a controlled environment. This physical release, combined with the endorphin rush that comes from high-intensity exercise, makes boxing one of the best forms of exercise for stress management.',
        source: 'Adams, R., & Kirkby, R. J. (2001). Exercise dependence and associated stress in amateur boxing: A study of psychological well-being. Journal of Sports Sciences, 19(5), 384-392.',
        alt: 'Person wrapping hands with red traditional wraps, standing in home boxing gym',
      },
      {
        img: 'https://a.storyblok.com/f/152150/3648x5472/dcaf888ef5/increased_metabolism_v2.jpg',
        title: 'Increased Metabolism',
        description: 'While weightlifting primarily focuses on building muscular strength and hypertrophy, boxing is a multifaceted workout that combines strength with cardiovascular endurance, agility, and coordination. Boxing sessions elicit greater cardiovascular responses due to the continuous movement and high-intensity nature of the sport. This makes it a superior full-body workout for improving overall fitness and metabolic health...',
        source: 'Smith, M. S. (2006). Physiological profile of elite junior and senior amateur boxers. Journal of Sports Science and Medicine, 5(CSSI), 74-89',
        alt: 'A man in camo shorts and boxing gloves punches a heavy bag in a gym, with large windows in the background.',
      },
      {
        img: 'https://a.storyblok.com/f/152150/3883x5824/5ee7ff6785/better_balance_posture_v2.jpg',
        title: 'Better Balance & Posture',
        description: 'Boxing improves balance, strengthens upper- body and core, boosts endurance, may increase alertness, Enhances mood, helps posture, improves hand-eye coordination, and it’s a Great way to fight mental illnesses.',
        source: 'Harvard Health Publishing, “Punch up your exercise routine with fitness boxing”',
        alt: 'Person boxing a FightCamp punching bag in a sunlit living room, with a TV and kitchen appliances in the background.',
      },
      {
        img: 'https://a.storyblok.com/f/152150/6192x8256/e274a05d7b/promote_longevity_v2.jpg',
        title: 'Promote Longevity',
        description: 'Research suggests that high-intensity training modalities like boxing can improve mitochondrial function and reduce cellular aging markers, making it a highly effective intervention for slowing the aging process and promoting longevity.',
        source: 'Gibala, M. J., & Little, J. P. (2010). Short-term sprint interval versus traditional endurance training: Similar initial adaptations in human skeletal muscle and exercise performance. Journal of Physiology, 588(6), 1011-1020.',
        alt: 'A person in a black tank top and shorts stands in a home gym holding FightCamp boxing gloves, with exercise equipment and a TV in the background.',
      },
      {
        img: 'https://a.storyblok.com/f/152150/6000x4000/9144d8f877/thomas_burn_more_calories.jpg',
        title: 'Burn More Calories, Faster',
        description: 'Boxing training sessions can burn up to 800 calories per hour, making it one of the most efficient forms of high-intensity interval training (HIIT). The combination of aerobic and anaerobic exercises in boxing elevates calorie expenditure both during and after the workout, due to the afterburn effect (excess post-exercise oxygen consumption or EPOC), which enhances fat oxidation for hours post-training.',
        source: 'LaForgia, J., Withers, R. T., & Gore, C. J. (2006). Effects of exercise intensity and duration on the excess post-exercise oxygen consumption. Journal of Sports Science, 24(12), 1247-1264.',
        alt: 'Person in black workout gear boxing a white punching bag labeled "FightCamp" in a dimly lit room.',
      },
    ];

    const isCardExpanded = (index: number) => expandedCards.value.has(index);

    const toggleCard = (index: number) => {
      if (expandedCards.value.has(index)) {
        expandedCards.value.delete(index);
      } else {
        expandedCards.value.add(index);
      }
      expandedCards.value = new Set(expandedCards.value);
    };

    return {
      cards,
      expandedCards,
      isCardExpanded,
      toggleCard,
    };
  },
});
